<template>
    <div class="source-chip" @click="openUrl">
        <div v-if="title && !filename" class="chip-nota">
            <span v-for="source_number in sources_number" v-bind:key="source_number" class="chip-source-number">[{{
                source_number }}]</span>
            <span class="chip-title">: {{ title }}</span>
            <!-- if prop timestamp is set, display date in format DD/MM/YYYY -->
            <span v-if="date" class="chip-timestamp"> - {{ formattedTimestamp }}</span>
        </div>
        <div :title="sinopsis" v-if="filename" class="chip-libro">
            <span class="chip-title" v-if="title">{{ title }} <span v-if="author"> - por {{ author }}</span></span>
            <span v-else class="chip-filename">{{ filename }}</span>
            <div v-for="source_number in sources_number" v-bind:key="source_number" class="page-reference">
                <span class="chip-source-number">[{{ source_number }}]</span>
                <span class="chip-page"> - página {{ pages[sources_number.indexOf(source_number)] }}</span>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        filename: {
            type: String,
            default: ''
        },
        pages: {
            type: Array,
            required: false,
            default: () => []
        },
        url: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        date: {
            type: String,
            default: ''
        },
        sources_number: {
            type: Array,
            required: false,
            default: () => []
        },
        sinopsis: {
            type: String,
            default: ''
        },
        author: {
            type: String,
            default: ''
        }
    },
    computed: {
        formattedTimestamp() {
            const date = new Date(this.date);
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            };
            return date.toLocaleString('es-AR', options);
        },
    },
    methods: {
        openUrl() {
            if (this.title && this.url) {
                window.open(this.url, '_blank');
            }
        }
    }
};
</script>

<style scoped>
.source-chip {
    display: inline-block;
    padding: 8px 24px;
    background-color: #fcfcfc;
    border-radius: 16px;
    cursor: pointer;
    margin-right: 12px;
    margin-bottom: 12px;
    border: 2px solid #e0e0e0;
    flex-basis: fit-content;
    flex-grow: 0;
    flex-shrink: 1;
    max-width: 30%;
}

.source-chip:hover {
    background-color: #fff;
    border: 2px solid #000;
}


.chip-title,
.chip-source-number {
    color: #f44336;
    font-weight: bold;
}

.chip-title {
    font-weight: 500;
    font-size: 13pt;
}

.chip-libro {}

.chip-filename {
    color: #f44336;
    font-weight: bold;
}

.chip-page {
    color: #666;
    font-weight: thin;
    font-size: 10pt;
}

.chip-timestamp {
    color: #666;
    font-weight: thin;
    font-size: 12pt;
}

@media screen and (max-width: 768px) {
    .source-chip {
        min-width: 100%;
        max-width: 100%;
        margin-right: 0;
    }

    .chip-title {
        font-size: 12pt;
    }

    .chip-timestamp {
        font-size: 10pt;
    }

    .chip-page {
        font-size: 8pt;
    }

    .chip-filename {
        font-size: 12pt;
    }

    .chip-source-number {
        font-size: 12pt;
    }

}
</style>